import axios from 'axios'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'

import { APP_ENV } from 'src/env'
import KnownError from 'src/lib/known-error'

import { handlePromise } from '../handlePromise'
import logger from '../logger'

/**
 * @typedef {Object} TTXResult
 * @property {string?} id User ID
 * @property {string?} email
 * @property {string?} organizationId
 * @property {string?} incidentId
 * @property {string?} simulationId
 * @property {string?} token
 * @property {Error?} tokenError
 */

/**
 * @param {string} ttxInviteToken The token
 * @returns {TTXResult}
 */
export default function useTTXUserData(ttxInviteToken) {
    /**
     * @type {ReturnType<typeof useState<TTXResult>}
     */
    const [data, setData] = useState({})

    useEffect(() => {
        async function run() {
            const searchParams = new URLSearchParams({
                ttxInviteToken,
            })
            const [httpError, result] = await handlePromise(
                axios.get(
                    APP_ENV.REACT_APP_ORNA_BACKEND_URL +
                        '/ttx/verify?' +
                        searchParams.toString()
                )
            )

            if (httpError) {
                logger.error(
                    'an error occurred while verifying ttx invite link'
                )
                logger.error(httpError)
                setData({
                    tokenError: new KnownError(
                        'An error occurred while validating invite token',
                        null,
                        httpError
                    ),
                })
                return
            }

            setData({ isTTXUser: true, ...result.data })
        }

        if (isEmpty(ttxInviteToken)) {
            return
        }

        run()
    }, [ttxInviteToken])

    return data
}
